import { render, staticRenderFns } from "./TestReportOfChemical.vue?vue&type=template&id=c00a7712&scoped=true&"
import script from "./TestReportOfChemical.vue?vue&type=script&lang=js&"
export * from "./TestReportOfChemical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c00a7712",
  null
  
)

export default component.exports